module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Serviços para Empresas")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Recargas")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas de serviço, verifique os valores:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-red"
  }, [_c('div', {
    staticClass: "recharge-value-red"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-red"
  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("40,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-yellow"
  }, [_c('div', {
    staticClass: "recharge-value-yellow"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-yellow"
  }, [_vm._v("1.000")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("70,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-green"
  }, [_c('div', {
    staticClass: "recharge-value-green"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-green"
  }, [_vm._v("1.500")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("90,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-blue"
  }, [_c('div', {
    staticClass: "recharge-value-blue"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-blue"
  }, [_vm._v("2.000")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("100,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge-last"
  }, [_c('div', {
    staticClass: "recharge-purple"
  }, [_c('div', {
    staticClass: "recharge-value-purple"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-purple"
  }, [_vm._v("2.000+")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n            Taxa de serviço:\n            "), _c('p', [_vm._v("5%")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('a', {
    staticClass: "btn btn-back",
    attrs: {
      "href": "javascript:window.history.back()"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-33db85fb!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/recharge-value-b2b.vue
// module id = 2089
// module chunks = 1